import { lazy } from 'react'

export default {
  Detail: lazy(() => import('./Detail')),
  List: lazy(() => import('./List')),
}